import { render, staticRenderFns } from "./AuthenticationRegister.vue?vue&type=template&id=656af675&"
import script from "./AuthenticationRegister.vue?vue&type=script&lang=js&"
export * from "./AuthenticationRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656af675')) {
      api.createRecord('656af675', component.options)
    } else {
      api.reload('656af675', component.options)
    }
    module.hot.accept("./AuthenticationRegister.vue?vue&type=template&id=656af675&", function () {
      api.rerender('656af675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthenticationRegister.vue"
export default component.exports